var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1287 15.6707C24.2444 6.5765 18.0506 0 13.9929 0C9.93406 0 3.74023 6.5765 2.85706 15.6707C2.16173 22.834 7.20639 28 13.9929 28C20.7794 28 25.8229 22.834 25.1287 15.6707Z",
    fill: "#1BC8B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5595 15.435C22.8011 7.62184 17.4788 1.97168 13.9928 1.97168C10.5068 1.97168 5.18448 7.62184 4.42615 15.435C3.82881 21.588 8.16298 26.026 13.9928 26.026C19.8226 26.026 24.1568 21.5892 23.5595 15.435Z",
    fill: "#53FFEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1329 16.9634C22.6776 15.8551 22.8479 13.1367 21.5132 10.8932C20.1797 8.64975 17.8452 7.72808 16.3006 8.83642C14.7559 9.94475 14.5856 12.6619 15.9191 14.9054C17.2537 17.1501 19.5882 18.0706 21.1329 16.9634ZM13.9019 17.5911C14.8726 16.8934 14.9787 15.1843 14.1387 13.7703C13.2987 12.3586 11.8311 11.7764 10.8592 12.4741C9.88741 13.1706 9.78125 14.8809 10.6212 16.2937C11.4612 17.7066 12.9312 18.2876 13.9019 17.5911ZM13.4866 9.46408C14.1212 9.00908 14.1947 7.89958 13.6499 6.98492C13.1074 6.07025 12.1519 5.69808 11.5184 6.15308C10.8837 6.60808 10.8102 7.71758 11.3551 8.63225C11.8976 9.54692 12.8531 9.91908 13.4866 9.46408Z",
    fill: "#1BC8B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerEgg);
export default __webpack_public_path__ + "static/media/banner_egg.d58270ad1fc05d0a266d94342b813f82.svg";
export { ForwardRef as ReactComponent };